import { Button, Center, Stack, Text } from '@chakra-ui/react';
import { FormikValues } from 'formik';

interface Props {
    hasPrevious?: boolean;
    onBackClick?: (values: FormikValues) => void;
    isLastStep: boolean;
    isFilled?: boolean;
    buttonWidth: string;
    hasSkipButton?: boolean;
    skipbuttonText?: string;
}

const FormNavigation = (props: Props) => {
    const {isLastStep, buttonWidth, hasSkipButton, skipbuttonText} = props;
    return (
        <Stack>
            <Center>
                {
                    <Button
                        type="submit"
                        h="48px"
                        borderRadius="100px"
                        mt="6"
                        bgGradient="linear(to-r, #9836ef, #3654fb)"
                        color="white"
                        width={buttonWidth ? buttonWidth : '350px'}
                    >
                        {isLastStep ? 'Finish →' : 'Next →'}
                    </Button>
                }
            </Center>
            <Center>
                {hasSkipButton && (
                    <Text as="button" type="submit" fontSize="15px" fontWeight={600} mt="6" mb='12'>
                        {skipbuttonText}
                    </Text>
                )}
            </Center>
        </Stack>
    );
};

export default FormNavigation;
